const alphabeticSort = (obj) => {
    const sortedEntries = Object.entries(obj).sort(([keyA], [keyB]) => keyA.localeCompare(keyB));
    return Object.fromEntries(sortedEntries);
}
export default alphabeticSort;